/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Delete_PermanentInputs */

const cs_settings_teams_delete_permanent = /** @type {(inputs: Settings_Teams_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazání týmu je trvalé a nelze jej vrátit zpět.`)
};

const en_settings_teams_delete_permanent = /** @type {(inputs: Settings_Teams_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting a team is permanent and cannot be undone.`)
};

/**
* | output |
* | --- |
* | "Deleting a team is permanent and cannot be undone." |
*
* @param {Settings_Teams_Delete_PermanentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_delete_permanent = /** @type {((inputs?: Settings_Teams_Delete_PermanentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Delete_PermanentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_delete_permanent(inputs)
	return cs_settings_teams_delete_permanent(inputs)
});